<template>
  <pagebreadcrumb :title="title" :text="text" :text1="text1" />
  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-12">
          <div class="company-detail-block pt-0">
            <div class="company-detail">
              <div class="company-detail-image">
                <img src="@/assets/img/img-04.jpg" class="img-fluid" alt="logo" />
              </div>
              <div class="company-title">
                <h4>Michael Stewart</h4>
                <p>UI UX Designer</p>
              </div>
            </div>
            <div class="company-address">
              <ul>
                <li><i class="feather-map-pin"></i>Los Angels</li>
                <li><i class="feather-calendar"></i>22 September 2023</li>
                <li><i class="feather-star"></i>5.0, 245 Reviews</li>
              </ul>
            </div>
            <div class="project-proposal-detail">
              <ul>
                <li>
                  <div class="proposal-detail-img">
                    <img src="@/assets/img/icon/computer-line.svg" alt="icons" />
                  </div>
                  <div class="proposal-detail text-capitalize">
                    <span class="d-block">Recommended</span>
                    <p class="mb-0">89%</p>
                  </div>
                </li>
                <li>
                  <div class="proposal-detail-img">
                    <img src="@/assets/img/icon/time-line.svg" alt="icons" />
                  </div>
                  <div class="proposal-detail text-capitalize">
                    <span class="d-block">Completed Projects</span>
                    <p class="mb-0">220</p>
                  </div>
                </li>
                <li>
                  <div class="proposal-detail-img">
                    <img src="@/assets/img/icon/time-line.svg" alt="icons" />
                  </div>
                  <div class="proposal-detail text-capitalize">
                    <span class="d-block">Ongoing Projects</span>
                    <p class="mb-0">10</p>
                  </div>
                </li>
                <li>
                  <div class="proposal-detail-img">
                    <img src="@/assets/img/icon/user-heart-line.svg" alt="icons" />
                  </div>
                  <div class="proposal-detail text-capitalize">
                    <span class="d-block">Feedbacks</span>
                    <p class="mb-0">78</p>
                  </div>
                </li>
                <li>
                  <div class="proposal-detail-img">
                    <img src="@/assets/img/icon/translate-2.svg" alt="icons" />
                  </div>
                  <div class="proposal-detail text-capitalize">
                    <span class="d-block">Rehired</span>
                    <p class="mb-0">Rehired</p>
                  </div>
                </li>
                <li>
                  <div class="proposal-detail-img">
                    <img src="@/assets/img/icon/translate.svg" alt="icons" />
                  </div>
                  <div class="proposal-detail text-capitalize">
                    <span class="d-block">Response Times</span>
                    <p class="mb-0">1 Hour</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="company-detail-block company-description">
            <h4 class="company-detail-title">Description</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
              quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat
              non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <p class="mb-0">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
              doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
              veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim
              ipsam consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
            </p>
          </div>
          <experience></experience>
          <div class="company-detail-block company-description">
            <h4 class="company-detail-title">Education</h4>
            <div class="experience-set">
              <div class="experience-set-img">
                <img src="@/assets/img/icon/report.png" alt="img" />
              </div>
              <div class="experience-set-content">
                <h5>Master Degree<span>2013 - 2016</span></h5>
                <span>Arizona State University</span>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                  veniam, quis nostrud exercitation ullamco laboris
                </p>
              </div>
            </div>
            <div class="experience-set">
              <div class="experience-set-img">
                <img src="@/assets/img/icon/report.png" alt="img" />
              </div>
              <div class="experience-set-content">
                <h5>Bachelor Degree<span>2010 - 2013</span></h5>
                <span>Arizona State University</span>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                  veniam, quis nostrud exercitation ullamco laboris
                </p>
              </div>
            </div>
          </div>
          <reviews></reviews>
        </div>

        <!-- Blog Sidebar -->
        <profile-sidebar></profile-sidebar>
        <!-- /Blog Sidebar -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "Freelancer Details",
      text: "Home",
      text1: "Freelancer Details",
    };
  },
};
</script>
